// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ipe-K","footer":"styles_footer__RGJv9","passCodeTooltip":"styles_passCodeTooltip__23hYf"};